<template>
  <v-card flat>
    <v-card-text v-if="loading" class="text-center">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      />
    </v-card-text>
    <v-card-text class="pa-0" v-else>
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th></th>
              <th class="text-left">
                Avg per User
              </th>
              <th class="text-left">
                Total
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="items.length === 0">
              <td class="text-center caption" colspan="4">No data</td>
            </tr>
            <template v-else>
              <tr
                v-for="item in items"
                :key="item.link"
              >
                <td class="caption">{{ item.link }}</td>
                <td class="caption">{{ (item.count / (item.users || 1)).toFixed(2) }}</td>
                <td class="caption">{{ item.count }}</td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiTable } from '@mdi/js';
export default {
  data () {
    return {
      mdiTable,
      loading: true,
      items: [],
      modal: false
    }
  },
  watch: {
    async '$route.params' () {
      await this.getData()
    }
  },
  async mounted () {
    await this.getData()
  },
  methods: {
    async getData () {
      this.loading = true
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/marketing/telemetry/links-clicked-by-user`, {
          params: {
            build_tag: this.$route.params.buildTag
          }
        }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.items = data
      }
      this.loading = false
    }
  }
}
</script>